/** Bit flags from backend `Attributes.GrammarRules`. */
export const GRAMMAR_RULE_BITS = {
  IsMasculine: 1,
  IsFeminine: 2,
  IsIsland: 4,
  IsPluralized: 8,
} as const
Object.freeze(GRAMMAR_RULE_BITS)
export type GRAMMAR_RULE_BITS = (typeof GRAMMAR_RULE_BITS)[keyof typeof GRAMMAR_RULE_BITS]
